export default "__VITE_ASSET__BvDwLT_$__"